import React from 'react';

export function usePrevious<V = any>(value: V): V {
  const ref = React.useRef<{ value: V }>({ value });
  React.useEffect(() => {
    ref.current.value = value;
  }, [value]);
  return ref?.current?.value;
}
